import { AntSwitch } from '@agro-club/agroclub-shared'
import { FormikProps } from 'formik'
import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { FormInput } from 'views/components/form/FormInput'
import { FormPhoneInput } from 'views/components/form/FormPhoneInput'
import { SharedModalContent, SharedModalInputs } from 'views/components/SharedModal'

const SwitchFormWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`

type Props = {
  formik: FormikProps<any>
  children?: ReactNode
}

export const CommonFields: FC<Props> = ({ formik, children }) => {
  const { t } = useTranslation(['userContact', 'common', 'user'])

  return (
    <SharedModalContent>
      <SharedModalInputs>
        <SwitchFormWrapper>
          <AntSwitch checked={formik.values.is_main} onChange={(value) => formik.setFieldValue('is_main', value)} />
          {t('mainContact')}
        </SwitchFormWrapper>

        {children}

        <FormInput label={t('position')} formik={formik} field="position" />
        <FormPhoneInput formik={formik} />
        <FormInput label={t('common:email')} formik={formik} field="email" />
      </SharedModalInputs>
    </SharedModalContent>
  )
}
